import VadImage from "vadimages-nextjs-image-optimizer";
import * as C from "@/components";
import * as P from "@/parts";
import React from "react";
import {ContentItem} from "@api";
import { SnaptixImageCarouselSlider } from "./SnaptixImageCarouselSlider";

export interface SnaptixImageCarouselProps {
    imageDirectory: string;
    pageContent: Record<string, ContentItem>;
}

export const SnaptixImageCarousel = ({ imageDirectory, pageContent }: SnaptixImageCarouselProps) => {
    const lifeIrritationsFrames = [1, 2, 3, 4, 5, 6].map((frame) => ({
        src: `${imageDirectory}lifes-irritations-${frame}.2.png`, alt: "Lifes irritations Frame", width: 500, height: 350,
    }));

    const mobileLifeIrritationsFrames = [1, 2, 3, 4, 5, 6].map((frame) => ({
        src: `${imageDirectory}mobile/life-irritations-${frame}.1.png`, alt: "Lifes irritations Frame", width: 270, height: 480,
    }));

    return (
        <>
            <div className='hidden md:block text-center mx-auto space-y-6 mb-20'>
                <h2 className='px-2 text-7xl max-w-[850px]'>
                    {pageContent['lifes-irritations.headline']?.data ?? ""}</h2>
                <p className='text-2xl'>
                    {pageContent['lifes-irritations.subhead']?.data ?? ""}</p>
            </div>
            <C.Card style={{ paddingBottom: 0 }} className='mx-3 mb-3 w-full'>
                <div className='block md:hidden text-center pt-4 space-y-5 md:mb-8'>
                    <h2 className='px-2'>
                        {pageContent['lifes-irritations.headline']?.data ?? ""}</h2>
                    <p className='px-2'>
                        {pageContent['lifes-irritations.subhead']?.data ?? ""}</p>
                </div>
                <div className='hidden md:block'>
                    <SnaptixImageCarouselSlider images={lifeIrritationsFrames} />
                </div>
                <div className='block md:hidden'>
                    <SnaptixImageCarouselSlider images={mobileLifeIrritationsFrames} startOffset={230} isMobile />
                </div>
                <div className='h-[510px] relative'>
                    <div className='absolute w-full bottom-0 z-20'>
                        <VadImage
                            className='mx-auto w-[175px] md:w-[225px]'
                            src={`${imageDirectory}snaptix-lifes-irritations.png`}
                            alt='Lifes irritations'
                            width={305}
                            height={400}
                        />
                    </div>
                </div>
            </C.Card>
        </>
    );
};
